(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'Viator',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $destination_id     = $form.find('input#viator-destination_id');
		var $tag_ids            = $form.find('#viator-tag_ids');
		var $search_type        = $form.find('input[type=radio][name="form_component_data[Viator][search_type]"]');
		var destination_search  = '.destination-search';

		Adzuki.Typeahead(
			destination_search,
			'/Viator/destinationSearch',
			function selectDestination(item) {
				$destination_id.val(item.destination_id).trigger('change');
				getTagsForDestination(item.destination_id);
			}
		);

		$(destination_search).click(function locationBoxClicked() {
			this.value = '';
			$destination_id.val('').trigger('change');
		});

		$destination_id.on('change', function destinationIdChanged() {
			clearAllTags();
		});

		$search_type.change(function searchTypeChanged() {
			selectSearchType(this.value);
		});

		$('.item').click(function itemClicked() {
			document.location = Adzuki.base_uri + '/Viator/view/' + $(this).data("id") + '/page_num:' + $(this).data("page-num") + '/code:' + $(this).data("product-code");
		});

		// if user clicked the star that is currently selected, uncheck the radio. without this code,
		// user cannot clear the stars without clearing the entire search criteria
		$('.star-minimum-rating label').click(function starClicked(e) {
			var $self     = $(this),
			    label_for = $self.attr('for'),
			    $radio    = $('#' + label_for);

			if ($radio.prop("checked")) {

				// uncheck radio
				$radio.prop("checked", false);
				e.preventDefault();
			}
		});

		function clearAllTags()
		{
			$tag_ids.empty();
			$tag_ids.selectpicker('refresh');
		}

		function getTagsForDestination(destination_id)
		{
			var tags = [];
			Adzuki.Ajax.get('/Viator/tagsByDestination/' + destination_id)
			.then(function gotTags(rows) {
				var sorted = Adzuki.Sort.alphabeticValue(rows);

				$.each(sorted, function loopTags(sKey, sValue) {
					tags.push($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				clearAllTags();

				$tag_ids.append(tags);
				$tag_ids.selectpicker('refresh');
			});
		}

		function selectSearchType(search_type)
		{
			$('#criteria_fields').addClass('hidden');
			$('#product_code_fields').addClass('hidden');

			if (search_type === 'search_by_criteria') {
				$('#criteria_fields').removeClass('hidden');
			}

			if (search_type === 'search_by_product_code') {
				$('#product_code_fields').removeClass('hidden');
			}
		}

	};

}(jQuery, window.Adzuki || {}));
